module.exports = __webpack_public_path__ + "img/few-clouds.8b4ad53c.svg";